import React, { Component } from 'react';
import DeviceStorage from '../DeviceStorage/DeviceStorage';
import PropTypes from 'prop-types';
import ImageButton from './../Button/ImageButton';
import Asset from '../../requests/apa/Asset';
import AAFPlayer from '../../AAFPlayer/AAFPlayer';
import { setMetricsEvent } from '../../actions/metrics';
import ChannelsSingleton from '../Epg/ChannelsSingleton';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import Npvr from './../../utils/Npvr';
import {
  showModal,
  AAF_MODAL_ERROR,
  MODAL_PIN,
  HIDE_MODAL
} from '../../actions/modal';
import { playFullMedia } from '../../actions/playmedia';
import Translator from '../../requests/apa/Translator';
import * as api from '../../requests/loader';
import * as userFilters from '../../containers/MyContent/settings';
import store from '../../store';
import { showNotification } from '../../actions/notification';
import Utils from '../../utils/Utils';
import AAF from '../../AAF/AAF';
import './action-bar.css';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import MultipleLangLive from '../../AAF/LanguageLive/MultipleLangLive';
import { setLastTouchReminder } from '../../reducers/user';
import PlayerStreamingUtils from '../../utils/PlayerStreamingUtils';
import { NpvrUtil } from '../../AAF/Npvr/NpvrUtil';
import NpvrUploader from '../../AAF/Npvr/NpvrUploader';
import { HideMiniObserver } from '../PersistentMiniEpg/MiniObserver';
import { Dates } from '../../packages/dates';
import channelBlockedUtil from '../../utils/ChannelBlockedUtil';
  import {UpdateCardFromRibbonUserObserver, DELETE_CARD, ADD_CARD} from '../PersistentMiniEpg/MiniObserver';
import logger from 'src/utils/logger/logger';

const constants = {
  buttons: {
    favorite: 1,
    lock: 2,
    record: 3,
    reminder: 4,
    subtitle: 5,
    guide: 6,
    season: 7,
    episode: 8,
    fromStart: 9
  }
};
Object.freeze(constants);

class ActionBar extends Component {
  constructor(props) {
    super(props);
    this.playerStreamingUtils = new PlayerStreamingUtils();
    this.isRecordingsEnabled = this.playerStreamingUtils.getButtonRecord('npvr_button_record');
    ///buscar an apa/metadata

    this.bindFunctions();
    this.channelsSingleton = new ChannelsSingleton();
    this.checkPinRequest();

    this.groupId = false;
    this.dateBegin = null;
    this.dateEnd = null;
    this.isCurrent = null;
    this.canPlayChannel = null;
    this.isRecordable = null;
    this.isPastEvent = null;
    this.isStartOver = null;
    this.hasNpvrStorage = null;
    this.channelId = null;
    this.hasTimehift = null;
    this.currentEvent = null;

    this.state = {
      isBlocked: true,
      isRecording: true,
      isFavorite: true,
      isReminder: false,
      isPinChannelActive: false,
      isFetching: false,
      pinCode: ''
    };
  }

  bindFunctions() {
    this.blockChannelHandler = this.blockChannelHandler.bind(this);
    this.unblockChannelHandler = this.unblockChannelHandler.bind(this);
    this.recordHandler = this.recordHandler.bind(this);
    this.cancelRecordHandler = this.cancelRecordHandler.bind(this);
    this.addFavoriteHandler = this.addFavoriteHandler.bind(this);
    this.deleteFavoriteHandler = this.deleteFavoriteHandler.bind(this);
    this.addReminderHandler = this.addReminderHandler.bind(this);
    this.deleteReminderHandler = this.deleteReminderHandler.bind(this);
    this.toggleIcon = this.toggleIcon.bind(this);
    this.showModalSubtitle = this.showModalSubtitle.bind(this);
    this.changeSubtitle = this.changeSubtitle.bind(this);
    this.showGuide = this.showGuide.bind(this);
    this.goToStart = this.goToStart.bind(this);
    this.NpvrDelete = this.NpvrDelete.bind(this);
    this.recordSeasonHandler = this.recordSeasonHandler.bind(this);
    this.recordEpisodeHandler = this.recordEpisodeHandler.bind(this);
    this.updateFavoritedState = this.updateFavoritedState.bind(this);
    this.updateRecordingState = this.updateRecordingState.bind(this);
    this.checkPinRequest = this.checkPinRequest.bind(this);
    this.checkBlockedChannel = this.checkBlockedChannel.bind(this);
    this.getReminderList = this.getReminderList.bind(this);
    this.handlePlayChannel = this.handlePlayChannel.bind(this);

    this.setOpacity = this.setOpacity.bind(this);
    this.setFetching = this.setFetching.bind(this);
    this.setterHandler = this.setterHandler.bind(this);

    this.showError = this.showError.bind(this);
  }

  async checkPinRequest() {
    const { user: { isAnonymous = true } = {}} = store.getState()

    if( isAnonymous ) {
      this.setState({ isPinChannelActive: false });
    } else {
      api.getPinStatus()
      .then(resp => {
        if (resp.status == '0' && resp.response) {
          const isPinChannelActive =
            resp.response.pin_channel && resp.response.pin_channel.status == 1;
          this.setState({ isPinChannelActive });
        } else {
          this.showError(resp.completeError && resp.completeError.errors);
        }
      })
      .catch(e => {
        this.showError(e);
      });
    }
  }

  async checkBlockedChannel(groupId) {
    api.checkBlockedChannel(groupId)
    // https://dlatvarg.atlassian.net/wiki/spaces/GCV/pages/212402394/user+controlpin+channels+check
    // El objetivo de esta API, es poder verificar los canales bloqueados por el usuario.
      .then(resp => {
        if (resp.status == '0' && resp.response) {
          this.setState({ isBlocked: true });
        } else {
          this.setState({ isBlocked: false });
        }
      })
      .catch(e => {
        this.showError(e);
      });
  }

  async getReminderList() {
    api.getReminders()
      .then(resp => {
        if (resp.status == '0' && resp.response) {
          //Validar wue es un arreglo por que esos de BAckend son unos loquillos
          if (Utils.isArray(resp.response)) {
            const reminder = resp.response.find(it => it.event_id === this.eventId);

            if (reminder) {
              this.setState({ isReminder: true, idReminder: reminder.id });
            } else {
              this.setState({ isReminder: false, idReminder: null });
            }
          } else {
            this.setState({ isReminder: false, idReminder: null });
          }
        } else {
          this.setState({ isReminder: false, idReminder: null });
        }
      })
      .catch(e => {
        this.showError(e);
      });
  }

  async handlePlayChannel() {
    logger.debug('[ActionBar] this.dateBegin', this.dateBegin);
    logger.debug('[ActionBar] this.dateEnd', this.dateEnd);
    if (EpgPersistence.isEnabled()) {
      HideMiniObserver.fire();
    }
    if (this.isPastEvent && this.isStartOver) {
      if (this.dateBegin && this.dateEnd) {
        let endUnix, beginUnix;
        if (EpgPersistence.isEnabled()) {
          endUnix = this.dateEnd;
          beginUnix = this.dateBegin;
        } else {
          endUnix = new Dates(this.dateEnd).unix();
          beginUnix = new Dates(this.dateBegin).unix();
        }
        logger.debug('[ActionBar] endUnix', endUnix);
        logger.debug('[ActionBar] beginUnix', beginUnix);
        const eventDates = AAF.Timeshift.replaceCatchupTime(this.groupId, beginUnix, endUnix);
        logger.debug('[ActionBar] eventDates', eventDates);

        if (eventDates) {
          const cparams = {
            playerstate: 'PLAYING',
            source: {
              videoid: this.groupId
            },
            size: {
              top: 0,
              left: 0,
              width: 1280,
              height: 720
            },
            ispreview: false,
            islive: false,
            ispip: false,
            starttime: eventDates.startTime,
            endtime: eventDates.endTime,
            event: this.currentEvent
          };

          store.dispatch(playFullMedia(cparams));
        } else {
          this.showError(
            Translator.get(
              'event_is_not_catchup',
              'Evento no está disponible (Evento no es catchup)'
            )
          );
        }
      }
    }
  }

  setOpacity(value) {
    const buttons = document.querySelectorAll(
      '.action-bar.container .action-bar-wrapper .col a'
    );

    if (buttons) {
      Array.prototype.forEach.call(buttons, function(button) {
        if (value) {
          button.className = button.className.replace('focusable', 'fetching');
        } else {
          button.className = button.className.replace('fetching', 'focusable');
        }
      });
    }

    this.setFetching(value);
  }

  setFetching(value) {
    this.setState({ isFetching: value });
  }

  componentDidMount() {}

  componentWillUnmount() {}

  componentWillReceiveProps(nextProps, prevState) {
    if (nextProps.channel !== this.props.channel) {
      if (!nextProps.channel) {
        // Fix para PIN Parental, como el action bar se recarga al ocultarse
        // se perdia la referencia del evento de la EPG
        return;
      }
      this.updateFavoritedState();
      const channel = this.channelsSingleton.getChannelByIdNow(nextProps.channel);
      this.groupId = channel ? channel.group_id : false;
      if (this.groupId) {
        this.checkPinRequest();
        this.checkBlockedChannel(this.groupId);
      }
    }

    if (nextProps.event && nextProps.event.id !== undefined) {

      this.currentEvent = nextProps.event;
      this.channelId = nextProps.event.channel_id;
      this.dateBegin = nextProps.event.date_begin;
      this.dateEnd = nextProps.event.date_end;
      this.eventId = nextProps.event.id;
      this.getReminderList();
      this.isCurrent = Utils.isDateBetween(this.dateBegin, this.dateEnd);
      this.canPlayChannel = ChannelsSingleton.canPlayChannel(this.groupId);
      this.isRecordable = nextProps.event.ext_recordable === '1';
      this.isPastEvent = Utils.isDateBetween(this.dateEnd, Utils.now(true).unix());
      this.isStartOver = nextProps.event.ext_startover == '1';
      this.hasTimehift = this.eventIsInTimeshiftWindow(nextProps.event, this.isPastEvent);
      // const npvr = ChannelsSingleton.getNpvrStorage(this.groupId);
      // this.eventStatus = npvr.getEventStatus(nextProps.event.id);
      if (NpvrUtil.recordingIconEnable().enable) {
        this.setState({
          isRecording: NpvrUploader.isEventRecording(this.eventId)
        });
        this.recording_id = NpvrUploader.getRecordingIdByEventId(this.eventId);
      } else {
        const npvr = new Npvr();
        npvr.isEventInRecordingOrScheduled(this.eventId).then(isRecording => {
          this.setState({
            isRecording
          });
        });
      }

      this.hasNpvrStorage =
        ChannelsSingleton.getNpvrStorage(this.groupId) != 0 ? true : false;
    }
  }

  eventIsInTimeshiftWindow(event, isPastEvent) {
    // Sólo para verificar eventos pasados
    if (!isPastEvent) return false;
    // timeshiftAllowed viene en segundos
    const timeshiftAllowedExeded =
      ChannelsSingleton.getTimeshift(event.channel_group_id || event.group_id) * 60 +
      AAF.Timeshift.calcTSExcedecTime();
    const now = Utils.now(true).unix();
    const beginUnix = !isNaN(event.date_begin)
      ? event.date_begin
      : EpgPersistence.needsOffset()
        ? new Dates(event.date_begin)
          .utcOffset(EpgPersistence.needsOffset(), true)
          .unix()
        : new Dates(event.date_begin).unix();
    const endUnix = !isNaN(event.date_end)
      ? event.date_end
      : EpgPersistence.needsOffset()
        ? new Dates(event.date_end)
          .utcOffset(EpgPersistence.needsOffset(), true)
          .unix()
        : new Dates(event.date_end).unix();
    const endTimeshif =
      beginUnix < now - timeshiftAllowedExeded
        ? ChannelsSingleton.getTimeshift(event.channel_group_id || event.group_id) * 60
        : timeshiftAllowedExeded;
    const isIn = endUnix <= now && endUnix > now - endTimeshif ? true : false;
    return isIn;
  }

  async updateFavoritedState() {
    const user = store.getState().user;

    if (user.isLoggedIn) {
      this.setOpacity(true);
      api.fetchFavoriteLoader(user, userFilters.default.myChannels)
        .then(favs => {
          const favorites = favs.response && favs.response.groups;
          const isFavorite = favorites.some(e => e.id === this.groupId);
          this.setState({ isFavorite }, this.setOpacity(false));
        })
        .catch(e => {
          this.showError(e);
        });
    }
  }

  async updateRecordingState() {
    const isRecording = this.eventStatus ? this.eventStatus : false;

    this.setState({
      isRecording
    });
  }

  unblockChannelHandler() {
    if (this.groupId && !this.state.isFetching) {
      this.setOpacity(true);

      api.unblockChannel(this.groupId)
        .then(resp => {
          if (resp.response && resp.status === '0') {
            const notificationProps = {
              show: true,
              title: 'Desbloqueo',
              msg: '¡El canal ha sido desbloqueado!',
              apaAsset: '',
              type: 'message'
            };
            this.showNotification(notificationProps);
            this.toggleIcon('isBlocked');
            this.updateBlockedChannels(false);
          } else {
            this.showError(resp.completeError && resp.completeError.errors);
          }
        })
        .catch(e => {
          this.showError(e);
        });
    }
  }

  blockChannelHandler() {
    if (this.groupId && !this.state.isFetching) {
      this.setOpacity(true);
      api.blockChannel(this.groupId)
        .then(resp => {
          if (resp.response && resp.status === '0') {
            const notificationProps = {
              show: true,
              title: '¡Bloqueado!',
              msg: 'Este canal ha sido agregado a tu lista de canales bloqueados.',
              apaAsset: '',
              type: 'message'
            };
            this.showNotification(notificationProps);
            this.toggleIcon('isBlocked');
            this.updateBlockedChannels(true);
          } else {
            this.showError(resp.completeError && resp.completeError.errors);
          }
        })
        .catch(e => {
          this.showError(e);
        });
    }
  }


  updateBlockedChannels(toBlock) {
    const {pin_channel} = store.getState().pinCodes;
    const channelList = pin_channel.info ? pin_channel.info : [];//channelBlockedUtil.get('blockedChannels');
    if(channelList && Array.isArray(channelList)){
      if (toBlock) {
        channelList.push(this.groupId);
      } else {
        const index = channelList.indexOf(this.groupId);
        channelList.splice(index, 1);
      }
      channelBlockedUtil.clear();
      channelBlockedUtil.set('blockedChannels', channelList);
    }
  }

  recordHandler() {
    if (this.state.isFetching) {
      return;
    }
    if (NpvrUtil.recordingIconEnable().enable) {
      if (!NpvrUploader.isEventRecording(this.eventId)) {
        this.setOpacity(true);
        NpvrUploader.add(this.eventId, this.groupId, this.channelId).then(recordingId => {
          this.recording_id = recordingId;
          this.setState({ isRecording: true }, () => {
            this.toggleIcon('isRecording');
            this.setOpacity(false);
          });
        });
      }
    } else {
      const npvr = new Npvr();
      const user = store.getState().user;
      try {
        if (!npvr.getEventStatus(this.eventId)) {
          this.setOpacity(true);
          npvr.add(user, this.eventId, this.channelId, this.groupId).then(
            ({ eventStatus, recording_id }) => {
              this.recording_id = recording_id;
              if (eventStatus === 'recording')
                this.setState({ isRecording: true }, () => {
                  this.toggleIcon('isRecording');
                  this.setOpacity(false);
                });
              //this.setEventStatus(eventStatus);
            }
          );
        }
      } catch (e) {
        logger.error(e);
      }
    }
  }

  async cancelRecordHandler() {
    if (this.state.isFetching) {
      return;
    }
    if (NpvrUtil.recordingIconEnable().enable) {
      const result = await NpvrUploader.delete(this.eventId, this.groupId, this.recording_id);
      if (result) {
        const notificationProps = {
          show: true,
          title: 'Grabar',
          msg: '¡Cancelando grabacion!',
          apaAsset: 'player_controls_recording_icon',
          type: 'message'
        };

        this.showNotification(notificationProps);
        this.toggleIcon('isRecording');
        this.recording_id = null;
        //this.setState({ isRecording: false });
      }
    } else {
      const user = store.getState().user;
      const list = await new Npvr().list(user.user_token);

      if (list && list.recordings) {
        const respList = list.recordings;
        if (respList && Array.isArray(respList)) {
          respList.map(record => {
            let id = record.channel && record.channel.event && record.channel.event.id;
            if (this.eventId == id) {
              this.recordingId = record.record_id;
            }
          });
          this.setOpacity(true);
          const npvr = new Npvr();
          this.recordingId &&
          npvr
            .remove(user.user_token, this.recordingId, this.eventId)
            .then(response => {
              if (response.success) {
                this.setState({ isRecording: false });
                this.toggleIcon('isRecording');
              } else {
                this.setOpacity(false);
              }
            });
        }
      }
    }
  }

  addFavoriteHandler() {
    if (this.groupId && !this.state.isFetching) {
      this.setOpacity(true);
      api.addFavorite(this.groupId)
        .then((resp) => {
          if (resp.response && resp.status === '0') {
            const notificationProps = {
              show: true,
              title: '¡Agregado!',
              msg: 'Este canal ha sido agregado a tu lista de favoritos.',
              faClass: 'fa-star',
              apaAsset: '',
              type: 'message'
            };
            this.showNotification(notificationProps);

            this.toggleIcon('isFavorite');
            UpdateCardFromRibbonUserObserver.fire({
              action: ADD_CARD,
              cardGroupId: this.groupId,
              ribbonIds: ['Mis-Canales'],
              card: this.channelsSingleton.getChannelByGroupIdNow(this.groupId)
            });
          } else {
            this.showError(resp.completeError && resp.completeError.errors);
          }
        })
        .catch(e => {
          this.showError(e);
        });
    }
  }

  deleteFavoriteHandler() {
    if (this.groupId && !this.state.isFetching) {
      this.setOpacity(true);
      api.deleteFavorite(this.groupId)
        .then(resp => {
          if (resp.data && resp.data.delete) {
            const notificationProps = {
              show: true,
              title: '¡Eliminado!',
              msg: 'Este canal ha sido eliminado de tu lista de favoritos.',
              faClass: 'fa-star',
              apaAsset: '',
              type: 'message'
            };
            this.showNotification(notificationProps);
            this.toggleIcon('isFavorite');
            UpdateCardFromRibbonUserObserver.fire({
              action: DELETE_CARD,
              cardGroupId: this.groupId,
              ribbonIds: ['Mis-Canales'],
            });
          } else {
            this.showError(resp.completeError && resp.completeError.errors);
          }
        })
        .catch(e => {
          this.showError(e);
        });
    }
  }

  addReminderHandler() {
    let exp_date_string = ''
    if (this.channelId && this.props.event && !this.state.isFetching) {
      if(EpgPersistence.isEnabled()){
        exp_date_string = EpgPersistence.needsOffset() ? new Dates().unix(this.dateBegin).utcOffset(EpgPersistence.needsOffset(),false).format('YYYY/MM/DD HH:mm:ss') : new Dates().unix(this.dateBegin).format('YYYY/MM/DD HH:mm:ss');
      }
      else{
        // just in case no EpgPersistence, but actionbar works only with EpgPersistence
        exp_date_string = this.dateBegin;
      }
      const exp_date = exp_date_string.replace(/\/|\s|:/g, '');
      let evType = this.props.event.type;

      if (evType == '0' || !evType) {
        evType = 'epg_serie';
      } else {
        evType = 'epg_event';
      }
      this.setOpacity(true);
      api.createReminder(this.props.event.id, exp_date, evType, this.channelId)
        .then(resp => {
          if (resp.lasttouch && resp.lasttouch.reminder) {
            // set new lasttouch Reminder in redux
            const lastTouchReminder = resp.lasttouch.reminder;
            store.dispatch(setLastTouchReminder(lastTouchReminder));
          }

          if (resp.response && resp.status === '0') {
            const notificationProps = {
              show: true,
              title: '¡Agregado!',
              msg: 'Te notificaremos cuando comience este programa.',
              apaAsset: '',
              type: 'message'
            };
            this.showNotification(notificationProps);
            //this.toggleIcon('isReminder');
            this.setOpacity(false);
            this.getReminderList();
          } else {
            this.showError(resp.completeError && resp.completeError.errors);
          }
        })
        .catch(e => {
          this.showError(e);
        });
    }
  }

  deleteReminderHandler() {
    if (this.state.idReminder && !this.state.isFetching) {
      this.setOpacity(true);
      api.deleteReminder(this.state.idReminder)
        .then(resp => {
          if (resp.lasttouch && resp.lasttouch.reminder) {
            // set new lasttouch Reminder in redux
            const lastTouchReminder = resp.lasttouch.reminder;
            store.dispatch(setLastTouchReminder(lastTouchReminder));
          }
          if (resp.response && resp.status === '0') {
            const notificationProps = {
              show: true,
              title: '¡Eliminado!',
              msg: 'El recordatorio ha sido cancelado',
              apaAsset: '',
              type: 'message'
            };
            this.showNotification(notificationProps);
            //this.toggleIcon('isReminder');
            this.setOpacity(false);
            this.getReminderList();
          } else {
            this.showError(resp.completeError && resp.completeError.errors);
          }
        })
        .catch(e => {
          this.showError(e);
        });
    }
  }

  toggleIcon(property) {
    const value = this.state[property];
    this.setState({ [property]: !value }, () => {
      this.setOpacity(false);
    });
  }

  showModalSubtitle() {
    this.props.showLangModal();
    if (this.props && typeof this.props.hideAction == 'function') {
      this.props.hideAction();
    }
    logger.debug('TODO: Implementacion nueva showModalSubtitle aqui ...');
  }

  changeSubtitle() {
    logger.debug('TODO:');
  }

  showGuide() {
    if (this.props.showGuide && Utils.isFunction(this.props.showGuide)) {
      this.props.showGuide();
    }
  }

  goToStart() {
    if (this.props.goToStart && Utils.isFunction(this.props.goToStart)) {
      this.props.goToStart();
    }
  }

  async recordSeasonHandler(){
    if (this.state.isFetching) {
      return;
    }
    this.sendMetric('grabacion');
    if (NpvrUtil.recordingIconEnable().enable) {
      if (!NpvrUploader.isEventRecording(this.eventId)) {
        if(NpvrUploader.isEventSerie(this.currentEvent)){
          this.setOpacity(true);
          NpvrUploader.addSerie(this.eventId, this.groupId, this.channelId, this.currentEvent.ext_series_id).then(recordingId => {
            this.recording_id = recordingId;
            if(recordingId){
              this.toggleIcon('isRecording');
            }
          });
        }else{
          this.setOpacity(true);
          NpvrUploader.add(this.eventId, this.groupId, this.channelId).then(recordingId => {
            this.recording_id = recordingId;
            if(recordingId){
              this.toggleIcon('isRecording');
            }
          });
        }
      }
    } else {
      const npvr = new Npvr();
      const user = store.getState().user;
      try {
        if (!npvr.getEventStatus(this.eventId)) {
          this.setOpacity(true);
          npvr.add(user, this.eventId, this.channelId, this.groupId).then(
            ({ eventStatus, recording_id }) => {
              this.recording_id = recording_id;
              if (eventStatus === 'recording')
                this.setState({ isRecording: true }, () => {
                  this.toggleIcon('isRecording');
                  this.setOpacity(false);
                });
              //this.setEventStatus(eventStatus);
            }
          );
        }
      } catch (e) {
        logger.error(e);
      }
    }
  }
  async recordEpisodeHandler(){
    if (this.state.isFetching) {
      return;
    }
    this.sendMetric('grabacion');
    if (NpvrUtil.recordingIconEnable().enable) {
      if (!NpvrUploader.isEventRecording(this.eventId)) {
          this.setOpacity(true);
          NpvrUploader.add(this.eventId, this.groupId, this.channelId).then(recordingId => {
            this.recording_id = recordingId;
            if (recordingId){
              this.toggleIcon('isRecording');
            }
          });
      }
    } else {
      const npvr = new Npvr();
      const user = store.getState().user;
      try {
        if (!npvr.getEventStatus(this.eventId)) {
          this.setOpacity(true);
          npvr.add(user, this.eventId, this.channelId, this.groupId).then(
            ({ eventStatus, recording_id }) => {
              this.recording_id = recording_id;
              if (eventStatus === 'recording')
                this.setState({ isRecording: true }, () => {
                  this.toggleIcon('isRecording');
                  this.setOpacity(false);
                });
              //this.setEventStatus(eventStatus);
            }
          );
        }
      } catch (e) {
        logger.error(e);
      }
    }
  }

  async NpvrDelete() {
    if (this.state.isFetching) {
      return;
    }
    if (NpvrUtil.recordingIconEnable().enable) {
        const result = await NpvrUploader.delete(this.eventId, this.groupId, this.recording_id);
        if (result) {
          const notificationProps = {
            show: true,
            title: 'Grabar',
            msg: '¡Cancelando grabacion!',
            apaAsset: 'player_controls_recording_icon',
            type: 'message'
          };
          this.showNotification(notificationProps);
          this.toggleIcon('isRecording');
          this.recording_id = null;
          //this.setState({ isRecording: false });
        }
    } else {
      const user = store.getState().user;
      const list = await new Npvr().list(user.user_token);

      if (list && list.recordings) {
        const respList = list.recordings;
        if (respList && Array.isArray(respList)) {
          respList.map(record => {
            let id = record.channel && record.channel.event && record.channel.event.id;
            if (this.eventId == id) {
              this.recordingId = record.record_id;
            }
          });
          this.setOpacity(true);
          const npvr = new Npvr();
          this.recordingId &&
          npvr
            .remove(user.user_token, this.recordingId, this.eventId)
            .then(response => {
              if (response.success) {
                this.setState({ isRecording: false });
                this.toggleIcon('isRecording');
              } else {
                this.setOpacity(false);
              }
            });
        }
      }
    }
  }

  sendDimension() {
    const payload = new AnalyticsDimensionSingleton().getPayload();
    store.dispatch(setMetricsEvent(payload));
    store.dispatch(setMetricsEvent({ type: 'executor' }));
  }

  sendMetric(action) {
    if (typeof setMetricsEvent === 'function') {
      const label = DeviceStorage.getItem('label-channel-analytics');
      store.dispatch(
        setMetricsEvent({
          hitType: 'event',
          eventCategory: 'TV',
          eventAction: `vcard/${this.groupId + ' ' + action}`,
          eventLabel: label
        })
      );
      store.dispatch(setMetricsEvent({ type: 'executor' }));
      this.sendDimension();
    }
  }

  setterHandler(value, pinIsCreated = null) {
    if (pinIsCreated) {
      store.dispatch({
        type: HIDE_MODAL,
        modalType: MODAL_PIN
      });
    }
    this.setState({ pinCode: value });
  }

  blockAction(funcion) {
    if (funcion === 'blockChannelHandler') {
      this.sendMetric('bloquear canal');
    } else {
      this.sendMetric('desbloquear canal');
    }
    if (this.state.pinCode === '') {
      const that = this;
      store.dispatch(
        showModal({
          modalType: MODAL_PIN,
          modalProps: {
            pinIsCreated: true,
            action: 'MP_CHECAR_STATUS',
            successCallBack: (currentPin, pinIsCreated) => {
              AAFPlayer.play();
              this.setterHandler(currentPin, pinIsCreated);
              pinIsCreated && that[funcion]();
            },
            failedCallBack: AAFPlayer.play
          }
        })
      );
    } else {
      this[funcion]();
    }
  }

  showNotification(notifiacion) {
    store.dispatch(showNotification(notifiacion));
  }

  isButtonVisible(id) {
    const user = store.getState().user;
    const canRecord =
      user.isLoggedIn &&
      this.canPlayChannel &&
      this.isRecordable &&
      // !this.isPastEvent && // se quita validacion para dejar grabar eventos pasados
      this.isRecordingsEnabled &&
      this.hasNpvrStorage;

    //const canRecord = true;

    switch (id) {
      case constants.buttons.favorite:
        return user.isLoggedIn;
      case constants.buttons.lock:
        return user.isLoggedIn && this.state.isPinChannelActive;
      case constants.buttons.record:
        return canRecord && this.props.event && !this.props.event.ext_series_id;
      case constants.buttons.reminder:
        return (
          user.isLoggedIn &&
          !this.isCurrent &&
          !Utils.isDateBetween(this.dateEnd, Utils.now(true).unix())
        );
      case constants.buttons.subtitle:
        return MultipleLangLive.isGroupIdEnabled(this.groupId, this.props.streamType());
      case constants.buttons.guide:
        return true;
      case constants.buttons.season:
        return canRecord && this.currentEvent && this.currentEvent.ext_series_id && !this.state.isRecording;
      case constants.buttons.episode:
        return canRecord && this.currentEvent && this.currentEvent.ext_series_id;
      case constants.buttons.fromStart:
        return (
          user.isLoggedIn &&
          this.canPlayChannel &&
          this.isPastEvent &&
          this.isStartOver &&
          this.hasTimehift
        );
      default:
        return false;
    }
  }

  showError(errors, callback) {
    if (errors) {
      const modal = {
        modalType: AAF_MODAL_ERROR,
        modalProps: {
          callback,
          content: errors
        }
      };
      store.dispatch(showModal(modal));
    }
    this.setOpacity(false);
  }

  render() {
    //Toggle
    const imgSrcChannel = this.state.isBlocked
      ? Asset.get('ab_unlockchannel', '/images/ab_unlockchannel.png')
      : Asset.get('ab_lockchannel', '/images/ab_lockchannel.png');
    const imgSrcRecord = this.state.isRecording
      ? Asset.get('ab_cancelrecord', '/images/ab_cancelrecord.png')
      : Asset.get('ab_recordchannel', '/images/ab_recordchannel.png');
    const imgSrcFavorite = this.state.isFavorite
      ? Asset.get('ab_delfavorite', '/images/ab_delfavorite.png')
      : Asset.get('ab_addfavorite', '/images/ab_addfavorite.png');
    const imgSrcReminder = this.state.isReminder
      ? Asset.get('ab_delreminder', '/images/ab_delreminder.png')
      : Asset.get('ab_addreminder', '/images/ab_addreminder.png');
    //Action
    const imgSrcSubtitle = Asset.get('ab_changesubtitle', '/images/ab_changesubtitle.png');
    const imgSrcGuide = Asset.get('ab_gotoguide', '/images/ab_gotoguide.png');
    const imgSrcSeason =   this.state.isRecording
    ? Asset.get('ab_cancelrecord', '/images/ab_cancelrecord.png')
    : Asset.get('ab_recordseason', '/images/ab_recordseason.png');
    const imgSrcEpisode = this.state.isRecording
    ? Asset.get('ab_cancelrecord', '/images/ab_cancelrecord.png')
    : Asset.get('ab_recordepisode', '/images/ab_recordepisode.png');
    const imgSrcFromBegin = Asset.get('ab_viewfrombegin', '/images/ab_viewfrombegin.png');

    return (
      <div className={`action-bar container ${this.props.visible ? '' : 'hide'}`}>
        <div className="action-bar-wrapper">
          <div className="row title">
            <span className="roboto bordered">{this.props.channel}</span>
            <span className="roboto bordered">{this.props.title}</span>
          </div>
          <div className="row">
            {this.isButtonVisible(constants.buttons.lock) && (
              <div className="col">
                <ImageButton
                  text={''}
                  order={[]}
                  imgSrc={imgSrcChannel}
                  imgId={'img_lockchannel'}
                  imgClassName={''}
                  onClick={() => {
                    const cb = this.state.isBlocked
                      ? 'unblockChannelHandler'
                      : 'blockChannelHandler';
                    this.blockAction(cb);
                  }}
                />
              </div>
            )}
            {this.isButtonVisible(constants.buttons.record) && (
              <div className="col">
                <ImageButton
                  text={''}
                  order={[]}
                  imgSrc={imgSrcRecord}
                  imgId={'img_record'}
                  imgClassName={''}
                  onClick={() => {
                    const cb = this.state.isRecording
                      ? this.cancelRecordHandler
                      : this.recordHandler;
                    if (Utils.isFunction(cb)) {
                      cb();
                    }
                  }}
                />
              </div>
            )}
            {this.isButtonVisible(constants.buttons.season) && (
              <div className="col">
                <ImageButton
                  text={''}
                  order={[]}
                  imgSrc={imgSrcSeason}
                  imgId={'img_recordSeason'}
                  imgClassName={''}
                  onClick={() => {
                    const cb = this.state.isRecording
                      ? this.NpvrDelete
                      : this.recordSeasonHandler;
                    if (Utils.isFunction(cb)) {
                      cb();
                    }
                  }}
                />
              </div>
            )}
            {this.isButtonVisible(constants.buttons.episode) && (
              <div className="col">
                <ImageButton
                  text={''}
                  order={[]}
                  imgSrc={imgSrcEpisode}
                  imgId={'img_recordEpisode'}
                  imgClassName={''}
                  onClick={() => {
                    const cb = this.state.isRecording
                      ? this.NpvrDelete
                      : this.recordEpisodeHandler;
                    if (Utils.isFunction(cb)) {
                      cb();
                    }
                  }}
                />
              </div>
            )}
            {this.isButtonVisible(constants.buttons.favorite) && (
              <div className="col">
                <ImageButton
                  text={''}
                  order={[]}
                  imgSrc={imgSrcFavorite}
                  imgId={'img_favorite'}
                  imgClassName={''}
                  //colorCode={config_remote_control ? "yellow" : null}
                  onClick={() => {
                    const cb = this.state.isFavorite
                      ? this.deleteFavoriteHandler
                      : this.addFavoriteHandler;
                    if (Utils.isFunction(cb)) {
                      cb();
                    }
                  }}
                />
              </div>
            )}
            {this.isButtonVisible(constants.buttons.reminder) && (
              <div className="col">
                <ImageButton
                  text={''}
                  order={[]}
                  imgSrc={imgSrcReminder}
                  imgId={'img_reminder'}
                  imgClassName={''}
                  onClick={() => {
                    const cb = this.state.isReminder
                      ? this.deleteReminderHandler
                      : this.addReminderHandler;
                    if (Utils.isFunction(cb)) {
                      cb();
                    }
                  }}
                />
              </div>
            )}
            {this.isButtonVisible(constants.buttons.subtitle) && (
              <div className="col">
                <ImageButton
                  text={''}
                  order={[]}
                  imgSrc={imgSrcSubtitle}
                  imgId={'img_subtitle'}
                  imgClassName={''}
                  onClick={() => {
                    this.showModalSubtitle();
                  }}
                />
              </div>
            )}
            {this.isButtonVisible(constants.buttons.guide) && (
              <div className="col">
                <ImageButton
                  text={''}
                  order={[]}
                  imgSrc={imgSrcGuide}
                  imgId={'img_goToGuide'}
                  imgClassName={''}
                  onClick={() => {
                    this.showGuide();
                  }}
                />
              </div>
            )}
            {this.isButtonVisible(constants.buttons.fromStart) && (
              <div className="col">
                <ImageButton
                  text={''}
                  order={[]}
                  imgSrc={imgSrcFromBegin}
                  imgId={'img_fromBegin'}
                  imgClassName={''}
                  onClick={() => {
                    this.handlePlayChannel();
                    this.props.hideMe();
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

ActionBar.propTypes = {
  isVisible: PropTypes.bool,
  onPressYellowButton: PropTypes.func
};

ActionBar.defaultProps = {
  isVisible: false,
  onPressYellowButton: () => {}
};

export default ActionBar;



// WEBPACK FOOTER //
// ./src/components/ActionBar/Index.jsx